import { useRef } from 'react';

import { IconRail } from './icon-rail';
import { IconRailPanel } from './icon-rail-panel';
import type { SidebarProps } from './types';
import { useSidebar } from './use-sidebar';

export function Sidebar({ menuGroups, businessName }: Readonly<SidebarProps>) {
    const { activeGroupId, onGroupSelect } = useSidebar(menuGroups);
    const containerRef = useRef<HTMLDivElement>(null);

    return (
        <div
            ref={containerRef}
            className='app-sidebar relative z-400 h-full shrink-0 bg-background-sidebar-faded2'>
            <IconRail
                groups={menuGroups}
                activeGroupId={activeGroupId}
                onGroupSelect={onGroupSelect}
                businessName={businessName}
            />
            <IconRailPanel groups={menuGroups} activeGroupId={activeGroupId} />
        </div>
    );
}
